module.exports = __webpack_public_path__ + "dz.svg?ff15f060b5abba792024a5b144e5a31d";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/dz.svg
// module id = 1078
// module chunks = 0